import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterProps'
})
export class FilterPropsPipe implements PipeTransform {

    transform(props: [string, any[]][], search: string): any[] {
        return props.filter(([key]) => {
            return key.toUpperCase().includes(search.toUpperCase());
        });
    }

}
